import {CreatePopup} from "components/Admin/Pages/CreatePopup/CreatePopup";
import {ImageField, ImageInput, SelectInput, TextInput, useTranslate} from "react-admin";
import {CapCategory, CapType} from "../../../dto/cap-dto";
import {useParams} from "react-router";
import {capService} from "../../../services/capService";

export const CapCreate = () => {
  const t = useTranslate();

  const {collectionId} = useParams();

  const types = Object.keys(CapType).map((type) => ({
    id: type,
    name: t(`resources.caps.options.type.${type}`),
  }));

  const categories = Object.keys(CapCategory).map((type) => ({
    id: type,
    name: t(`resources.caps.options.category.${type}`),
  }));

  return (
    <CreatePopup
      createQuery={(params: { data: any }) => capService.create({
        data: {
          ...params.data,
          collection: collectionId
        }
      })}
      maxWidth="sm"
    >
      <SelectInput source="type" fullWidth choices={types} defaultValue={"COMMON"} />
      <SelectInput source="category" fullWidth choices={categories}/>
      <ImageInput source="texture.albedoTransparency" fullWidth
                  accept={{'image/*': ['.png', '.jpg']}}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ImageInput source="texture.albedoTransparency2" fullWidth
                  accept={{'image/*': ['.png', '.jpg']}}>
        <ImageField source="src" title="title"/>
      </ImageInput>
    </CreatePopup>
  );
};